import { render, staticRenderFns } from "./AssetReviewCommentEditor.vue?vue&type=template&id=24a18a1c"
import script from "./AssetReviewCommentEditor.vue?vue&type=script&lang=js"
export * from "./AssetReviewCommentEditor.vue?vue&type=script&lang=js"
import style0 from "./AssetReviewCommentEditor.vue?vue&type=style&index=0&id=24a18a1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports